module.exports = __webpack_public_path__ + "static/media/calendar.4164161b.svg";